export interface BeforeunloadOptions {
  originWindow?: Window;
}

export interface Deps {
  beforeunloadOptions?: BeforeunloadOptions;
}
